import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
          S. Jawwad Ali
          <br/>
          s_jawwad_ali@yahoo.com
      </header>
    </div>
  );
}

export default App;
